export const TEXT = {
  heading: "Here's where your jobs live.",
  subHeading: "Let's add your first job",
};
